import type { Workspace } from '@/constants/workspaces'

export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  section?: 'operacao' | 'cadastros' | 'sistema' | 'service_desk' | 'ai_agents'
  // Ferramenta à qual o item pertence. Ausente = 'crm'.
  workspace?: Workspace
  requiresAdmin?: boolean
  // Nível mínimo no Easy AI Agents para ver o item (viewer/reviewer/admin).
  requiresAiAgents?: 'viewer' | 'reviewer' | 'admin'
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    // ───────────────────────── Workspace: CRM ─────────────────────────
    // ───────────────────── Workspace: AI Agents (interno) ─────────────────────
    {
      name: 'ai-home',
      displayName: 'menu.aiAgentsHome',
      section: 'ai_agents',
      workspace: 'ai-agents',
      requiresAiAgents: 'viewer',
      meta: {
        icon: 'space_dashboard',
      },
    },
    {
      name: 'ai-feedbacks',
      displayName: 'menu.aiAgentsFeedbacks',
      section: 'ai_agents',
      workspace: 'ai-agents',
      requiresAiAgents: 'viewer',
      meta: {
        icon: 'smart_toy',
      },
    },
    {
      name: 'ai-review',
      displayName: 'menu.aiAgentsReview',
      section: 'ai_agents',
      workspace: 'ai-agents',
      requiresAiAgents: 'reviewer',
      meta: {
        icon: 'fact_check',
      },
    },
    {
      name: 'ai-settings',
      displayName: 'menu.aiAgentsSettings',
      section: 'ai_agents',
      workspace: 'ai-agents',
      requiresAiAgents: 'admin',
      meta: {
        icon: 'tune',
      },
    },
    {
      name: 'registration',
      displayName: 'menu.coordinates_registry',
      section: 'cadastros',
      meta: {
        icon: 'my_location',
      },
    },
    {
      name: 'brands',
      displayName: 'menu.brands',
      section: 'cadastros',
      meta: {
        icon: 'sell',
      },
    },
    {
      name: 'modules',
      displayName: 'menu.modules',
      section: 'cadastros',
      meta: {
        icon: 'view_module',
      },
    },
    {
      name: 'pilots',
      displayName: 'menu.pilots',
      section: 'cadastros',
      meta: {
        icon: 'science',
      },
    },
    {
      name: 'data_integration_types',
      displayName: 'data_integration_types.data_integration_types',
      section: 'cadastros',
      meta: {
        icon: 'timeline',
      },
    },
    {
      name: 'database_names',
      displayName: 'database_names.database_names',
      section: 'cadastros',
      meta: {
        icon: 'storage',
      },
    },
    {
      name: 'companies',
      displayName: 'menu.companies',
      section: 'cadastros',
      meta: {
        icon: 'work',
      },
    },
    {
      name: 'localities',
      displayName: 'localities.localities',
      section: 'cadastros',
      meta: {
        icon: 'apartment',
      },
      children: [
        {
          name: 'localities',
          displayName: 'localities.localities',
        },
        {
          name: 'locality_types',
          displayName: 'locality_types.locality_types_CDs',
        },
        {
          name: 'sort-types',
          displayName: 'menu.sort_types',
        },
        {
          name: 'palletization_types',
          displayName: 'menu.palletization_types',
        },
      ],
    },
    {
      name: 'contacts',
      displayName: 'contacts.contacts',
      section: 'cadastros',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'users',
      displayName: 'users.users',
      section: 'sistema',
      meta: {
        icon: 'group',
      },
      requiresAdmin: true,
    },
    {
      name: 'audits',
      displayName: 'menu.audits',
      section: 'sistema',
      meta: {
        icon: 'content_paste_search',
      },
      children: [
        {
          name: 'audits',
          displayName: 'menu.audits',
        },
        {
          name: 'notifications',
          displayName: 'menu.notifications',
        },
      ],
    },
    {
      name: 'preferences',
      displayName: 'menu.preferences',
      section: 'sistema',
      meta: {
        icon: 'manage_accounts',
      },
    },

    // ──────────────────── Workspace: Service Desk ────────────────────
    {
      name: 'sd-home',
      displayName: 'menu.visao_geral',
      section: 'service_desk',
      workspace: 'service-desk',
      meta: {
        icon: 'space_dashboard',
      },
    },
    {
      name: 'sd-sla',
      displayName: 'menu.central_sla',
      section: 'service_desk',
      workspace: 'service-desk',
      meta: {
        icon: 'timer',
      },
    },
    {
      name: 'sd-tickets',
      displayName: 'menu.tickets',
      section: 'service_desk',
      workspace: 'service-desk',
      meta: {
        icon: 'confirmation_number',
      },
    },
    {
      name: 'project-home',
      displayName: 'menu.project_home',
      section: 'project',
      workspace: 'project',
      meta: {
        icon: 'space_dashboard',
      },
    },
    {
      name: 'project-projetos',
      displayName: 'menu.projetos',
      section: 'project',
      workspace: 'project',
      meta: {
        icon: 'view_kanban',
      },
    },
    {
      name: 'project-implantacoes',
      displayName: 'menu.implantacoes',
      section: 'project',
      workspace: 'project',
      meta: {
        icon: 'rocket_launch',
      },
    },
    {
      name: 'project-gestao',
      displayName: 'menu.deployment_management',
      section: 'project',
      workspace: 'project',
      meta: {
        icon: 'calendar_view_week',
      },
    },
    {
      name: 'sd-escala',
      displayName: 'menu.escala',
      section: 'service_desk',
      workspace: 'service-desk',
      meta: {
        icon: 'schedule',
      },
    },
    {
      name: 'sd-atendimentos',
      displayName: 'menu.atendimentos',
      section: 'service_desk',
      workspace: 'service-desk',
      meta: {
        icon: 'event_note',
      },
    },
    {
      name: 'sd-slack-auditoria',
      displayName: 'menu.notificacoes_slack',
      section: 'service_desk',
      workspace: 'service-desk',
      requiresAdmin: true,
      meta: {
        icon: 'forum',
      },
    },
    // Mapa e Indicadores são telas do CRM: tudo que elas mostram é CD, cliente
    // e marca. Sem `workspace` elas caem no padrão, que é o CRM.
    {
      name: 'map',
      displayName: 'localities.map',
      section: 'operacao',
      meta: {
        icon: 'public',
      },
    },
    {
      name: 'indicators',
      displayName: 'localities.indicators',
      section: 'operacao',
      meta: {
        icon: 'assessment',
      },
    },
    // ── Easy Monitor ──────────────────────────────────────────────────
    {
      name: 'monitoring',
      displayName: 'menu.monitoring',
      section: 'operacao',
      workspace: 'monitor',
      meta: {
        icon: 'monitor_heart',
      },
    },
  ] as INavigationRoute[],
}
